export const PRIORITY_OPTIONS = {
  random: {
    id: "random",
    label: "Tilfældig",
    orderBy: null,
    descendingOrder: false,
  },
  creationDateDesc: {
    id: "creationDateDesc",
    label: "Nyeste firmaer først",
    orderBy: "BasicInfo.CreationDate",
    descendingOrder: true,
  },
  creationDateAsc: {
    id: "creationDateAsc",
    label: "Ældste firmaer først",
    orderBy: "BasicInfo.CreationDate",
    descendingOrder: false,
  },
  employeeCountDesc: {
    id: "employeeCountDesc",
    label: "Firmaer med flest ansatte først",
    orderBy: "employees",
    descendingOrder: true,
  },
  employeeCountAsc: {
    id: "employeeCountAsc",
    label: "Firmaer med færrest ansatte først",
    orderBy: "employees",
    descendingOrder: false,
  },
  contactHasPhoneFirst: {
    id: "contactHasPhoneFirst",
    label: "Kontaktpersoner med telefon først",
    orderBy: "contacthasphone",
    descendingOrder: true,
  },
} as const;
